import {orderBy} from 'lodash';

import {FilterTypes} from '@ey/canvascoreservices/Filters';

import {labels, currentResource} from '../../../util/utils';

export const ContactsDBFilterEntityConfiguration = {
	country: {
		endpoint: 'countries',
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		entityMapping: (response) => {
			let countries = response;

			countries = orderBy(countries, (country) => country.countryName);

			return countries.map((country) => ({
				value: country.countryId,
				label: country.countryName
			}));
		},
		getDisplayValue: (id, entityType, _filterData) => {
			let value;

			if (_filterData && _filterData.byId) {
				value = _filterData.byId[id]?.label;
			}

			return value;
		}
	},
	groupRole: {
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		getDisplayValue: (id, entityType, _filterData) => currentResource.groupRole.find((x) => x.value === id)?.label
	},
	engagement: {
		endpoint: 'engagements',
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		entityMapping: (response) => {
			let engagements = response;

			engagements = orderBy(engagements, (engagement) => engagement.engagementDescription);

			return engagements.map((engagement) => ({
				value: engagement.canvasEngagementId,
				label: engagement.engagementDescription
			}));
		},
		getDisplayValue: (id, entityType, _filterData) => {
			let value;

			if (_filterData && _filterData.byId) {
				value = _filterData.byId[id]?.label;
			}

			return value;
		}
	},
	userType: {
		getDisplayValue: (id, entityType, _filterData) => currentResource.userType.find((x) => x.value === id)?.label
	},
	serviceLine: {
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		getDisplayValue: (id, entityType, _filterData) => {
			let value;

			if (_filterData && _filterData.byId) {
				value = _filterData.byId[id]?.label;
			}

			return value;
		}
	},
	role: {
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		getDisplayValue: (id, entityType, _filterData) => {
			let value;

			if (_filterData && _filterData.byId) {
				value = _filterData.byId[id]?.label;
			}

			return value;
		}
	},
	tag: {
		endpoint: '',
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		entityMapping: (response) => {
			let tags = response.tags;

			tags = orderBy(tags, (tag) => tag.tagName);

			return tags.map((value) => ({
				value: value.id,
				label:
					currentResource.tags.find((tag) => tag.id?.toLowerCase() === value?.key?.toLowerCase())?.name || value?.name
			}));
		},
		getDisplayValue: (id, entityType, _filterData) => {
			let value;

			if (_filterData && _filterData.byId) {
				value = _filterData.byId[id]?.label;
			}

			return value;
		}
	}
};

const getValue = (id, _filterData) => {
	let value;

	if (_filterData && _filterData.data.byId) {
		value = _filterData.data.byId[id]?.label;
	}

	return value;
};

export const MessageLogFilterEntityConfiguration = {
	messageType: {
		getDisplayValue: (id, entityType, _filterData) => currentResource.MessageType.find((x) => x.value === id)?.label
	},
	sentBy: {
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		getDisplayValue: (id, entityType, _filterData) => {
			return getValue(id, _filterData);
		}
	},
	fromEntity: {
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		getDisplayValue: (id, entityType, _filterData) => {
			return getValue(id, _filterData);
		}
	},
	toEntity: {
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		getDisplayValue: (id, entityType, _filterData) => {
			return getValue(id, _filterData);
		}
	},
	toCountry: {
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		getDisplayValue: (id, entityType, _filterData) => {
			return getValue(id, _filterData);
		}
	},
	toGroupRole: {
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		getDisplayValue: (id, entityType, _filterData) => {
			return getValue(id, _filterData);
		}
	},
	toEngagement: {
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		getDisplayValue: (id, entityType, _filterData) => {
			return getValue(id, _filterData);
		}
	},
	toServiceLine: {
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		getDisplayValue: (id, entityType, _filterData) => {
			return getValue(id, _filterData);
		}
	},
	toRole: {
		entityFilter: (entityFilters) => ({
			projectId: entityFilters.projectId
		}),
		getDisplayValue: (id, entityType, _filterData) => {
			return getValue(id, _filterData);
		}
	}
};

export const FilterTypeConfiguration = {
	[FilterTypes.boolean]: {
		getDisplayValue: (value) => (value ? labels.filterYes : labels.filterNo)
	}
};

export const ContactsDBFilterEntityTypes = {
	engagement: 'engagement',
	country: 'country',
	tag: 'tag',
	grouprole: 'grouprole',
	serviceline: 'serviceline',
	role: 'role'
};

export const MessageLogFilterEntityTypes = {
	sentBy: 'sentBy',
	fromEntity: 'fromEntity',
	toEntity: 'toEntity',
	toCountry: 'toCountry',
	toGroupRole: 'toGroupRole',
	toEngagement: 'toEngagement',
	toServiceLine: 'toServiceLine',
	toRole: 'toRole'
};

export const FilterEntityTypes = {
	...ContactsDBFilterEntityTypes
};

export const FilterEntityConfiguration = {
	...ContactsDBFilterEntityConfiguration
};
